import {closePageOverlay, showPageOverlay} from './MainNavigationHandler';

export function initProjectButton(): void {
  const projectButton = document.querySelector('.js-projectButton');
  if (!projectButton) {
    return;
  }
  projectButton.addEventListener('click', () => {
    const project = projectButton.closest('.js-project');
    if (project?.classList.contains('project--showMobile')) {
      project?.classList.remove('project--showMobile');
      closePageOverlay(0);
    } else {
      project?.classList.add('project--showMobile');
      showPageOverlay();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeContentMenu();
      closePageOverlay(0);
    }
  });

  // close content menu on click on anchor links
  document.querySelectorAll('.js-contentNavLink').forEach((link) => {
    link.addEventListener('click', () => {
      closeContentMenu();
      closePageOverlay(0);
    });
  });
}

export function closeContentMenu() {
  document.querySelector('.js-project')?.classList.remove('project--showMobile');
}
